import classes from 'components/widgets/RiskRegisterTabs/components/Tab/Tab.module.scss';

export const Tab = ({ title }: { title: string }) => {
    return (
        <div className={classes.tab}>
            <div className={`${classes.title}`}>{title}</div>
        </div>
    );
};
